<template>
  <div class="register-select">
    <div class="personage">
      <img src="@/assets/img/account/signup_choose_single_icon_01.png" alt />
      <div @click="routerTo(0)" class="butn">个人用户注册</div>
    </div>
    <div class="enterprise">
      <img src="@/assets/img/account/signup_choose_company_icon_01.png" alt />
      <div @click="routerTo(1)" class="butn">企业用户注册</div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    var pagename = window.top.document.URL
    var temp2 = pagename.split('?')[1];
    var pram2 = new URLSearchParams('?'+temp2);
   this.fromPromoCode =pram2.get('fromPromoCode')


  },
 methods:{
     routerTo(type){
       if(this.fromPromoCode){
         this.$router.push({
           name: 'register',
           params: {
             type:type,
             fromPromoCode:this.fromPromoCode
           }
         })
       }else {
         this.$router.push({
           name: 'register',
           params: {
             type:type,
             fromPromoCode:0
           }
         })
       }

     }
 }
};
</script>

<style scoped type="text/css">
.register-select {
    display: flex;
    width: 520px;
    justify-content: space-between;
    margin-top: 63px;
}
.personage .butn{
    background-color: #19BC73;
}
img{
  border-radius: 50%;
}
.enterprise .butn{
    background-color: #32ACFF;
}
.butn{
    width:219px;
    height:39px;
    border-radius:24px;
    font-size: 16px;
    color: #fff;
    margin-top: 42px;
    line-height: 39px;
    margin-bottom: 200px;
    cursor: pointer;
}
</style>>

